import React from "react";
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

export default function logo(props) {
  return <React.Fragment>
      {props.color === 'white' ? <img src={`${config.cdnUrl}/static/images/give-monthly-giving-white-2x.png`} height='40px' alt="" /> : null }
			{props.color === 'black' ? <img src={`${config.cdnUrl}/static/images/give-monthly-giving-2x.png`} height='40px' alt="" /> : null }
			{props.color !== 'black' && props.color !== 'white'  ? <img src={`${config.cdnUrl}/static/images/give-monthly-giving-2x.png`} height="40px" alt="give-logo"/> : null }
    </React.Fragment>;
}


